import styled from "styled-components";
import { BiChevronDown } from "react-icons/bi";
import { useState } from "react";

interface OrderByProps {
  options: string[];
  onClick?(value?: any): void;
}

interface OptionsProps {
  isOpen: boolean;
}

export function OrderBy({ options, onClick }: OrderByProps) {
  const [selected, setSelected] = useState(options[0]);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenOrderBy = () => {
    setIsOpen(!isOpen);
  }

  const handleSelectOption = (option: string) => {
    setSelected(option);
    onClick && onClick(option);
  }

  return (
    <Content onClick={() => handleOpenOrderBy()}>
      <Selected>
        <span>{selected}</span>
        <ChevronUI size={32} />
      </Selected>
      <Options isOpen={isOpen}>
        {options?.map(option => (
          option !== selected && <Option key={option} onClick={() => handleSelectOption(option)}>{option}</Option>
        ))}
      </Options>
    </Content>
  );
}

const Content = styled.div`
  background-color: ${({ theme }) => theme.colors.blue.dark};
  color: #fff;
  width: 100%;
  max-width: 260px;
  border-radius: 32px;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
  z-index: 1;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    margin: auto;
  }
`;

const Selected = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 0 32px;
  position: relative;
  z-index: 3;
`;

const Options = styled.div<OptionsProps>`
  visibility: ${({ isOpen }) => isOpen ? 'visible' : 'hidden'};
  opacity: ${({ isOpen }) => isOpen ? 1 : 0};
  position: absolute;
  top: ${({ isOpen }) => isOpen ? '18px' : '6px'};
  background-color: ${({ theme }) => theme.colors.blue.dark};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 0 8px;
  max-width: 260px;
  z-index: 2;
  transition: all 0.2s;
`;

const Option = styled.span`
  padding: 4px 32px;
`;

const ChevronUI = styled(BiChevronDown)`
  color: ${({ theme }) => theme.colors.pink.light};
`;